import Vue from 'vue'
import axios from '@plugins/axios'
import store from '@state/store'
import config from '@src/app.config'
const env = config.env
const appConfig = config[env]

export const state = {
  questionsProject: {
    results: []
  },
  question: {},
  module: {},
  loadingQuestions: false,
  isSubmitingQuestion: false,
  questionTypes: [
    {
      value: 0,
      text: 'Si/No (porcentaje de certeza)',
      type_graph: 'donut',
      multiple: 'yesno',
      add_percentage: true,
      help_text: `La experta o el experto deberá realizar la selección entre "Si" o "No" con el propósito de dar 
              su opinión sobre el escenario planteado. Después, deberá determinar el porcentaje de probabilidad 
              de ocurrencia de la condición elegida.`
    }, {
      value: 1,
      text: 'Porcentaje único',
      type_graph: 'radialBar',
      multiple: 'no',
      add_percentage: false,
      help_text: `La experta o el experto deberá elegir el porcentaje de probabilidad de ocurrencia para el 
                  escenario planteado con base en sus conocimiento, criterio y experiencia.`
    }, {
      value: 2,
      text: 'Porcentaje múltiple',
      type_graph: 'donut',
      multiple: 'percentage',
      add_percentage: false,
      help_text: `La experta o el experto deberá asignarle un porcentaje de probabilidad de ocurrencia a las 
                  iniciativas planetadas, la suma total del porcentaje asignado no debe superar el 100% entre todas.`
    }, {
      value: 3,
      text: 'Selección única (porcentaje de certeza)',
      type_graph: 'donut',
      multiple: 'unique',
      add_percentage: true,
      help_text: `La experta o el experto deberá elegir una probabilidad de las planteadas y luego darle 
                  un porcentaje de ocurrencia a esta probabilidad seleccionada.`
    }, {
      value: 4,
      text: 'Selección múltiple',
      type_graph: 'donut',
      multiple: 'multiple',
      add_percentage: false,
      help_text: `La experta o el experto podrá elegir las probabilidades que contiene el escenario y asignarle 
                  una probabilidad de ocurrencia a cada probabilidad elegida en porcentaje.`
    }, {
      value: 5,
      text: 'Porcentaje múltiple 2',
      type_graph: 'donut',
      multiple: 'percentage2',
      add_percentage: false,
      help_text: `la experta o el experto deberá elegir entre las probabilidades que considere se van a dar en el futuro 
                y deberá distribuir un porcentaje que no supere el 100% entre las elegidas.`
    }]

}

export const getters = {
  questionsProjects: state => state.questionsProject,
  loadingQuestions: state => state.loadingQuestions,
  isSubmitingQuestion: state => state.isSubmitingQuestion,
  isSubmitingAnswer: state => state.isSubmitingAnswer,
  questionTypes: state => state.questionTypes
}

export const mutations = {
  SET_QUESTIONS(state, data) {
    state.questionsProject = data
  },
  SET_CACHE(state, { key, value }) {
    Vue.set(state, key, value)
  },
  SET_LOADING(state, data) {
    state.loadingQuestions = data
  }
}

export const actions = {
  fetchQuestions({ commit }, { query, projectId }) {
    store.dispatch('utils/loaderMessage', 'Cargando preguntas...')
    commit('SET_CACHE', { key: 'loadingQuestions', value: true })
    axios.get(appConfig.server_url + `/projects_management/pronostic_project/${projectId}/?${query}`)
      .then(resp => {
        commit('SET_QUESTIONS', resp.data)
        commit('SET_CACHE', { key: 'loadingQuestions', value: false })
        store.dispatch('utils/loaderMessage', '')
      })
      .catch(error => {
        commit('SET_CACHE', { key: 'loadingQuestions', value: false })
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: `${error}` })
        store.dispatch('utils/loaderMessage', '')
      })
  },
  createUpdateQuestion({ commit, dispatch }, data) {
    store.dispatch('utils/loaderMessage', 'Guardando pregunta...')
    commit('SET_CACHE', { key: 'isSubmitingQuestion', value: true })
    let promise = null
    var action = 'create'
    if (data.url) {
      promise = axios.put(data.url, data)
      action = 'update'
    } else {
      promise = axios.post(appConfig.server_url + `/projects_management/question/`, data)
    }
    promise.then((resp) => {
      commit('SET_CACHE', { key: 'isSubmitingQuestion', value: false })
      if (data.answers) {
        dispatch('createAnswers', { answers: data.answers, question: resp.data, action: action, project: data.project_ins })
      } else {
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: `Pregunta guardada correctamente` })
      }
      store.dispatch('pronostics/fetchProjects', data.project_ins.id)
      store.dispatch('utils/loaderMessage', '')
      dispatch(
        'fetchQuestions',
        { query: `project__id=${data.project_ins.id}&opc=2`, projectId: data.project_ins.id }
      )
    })
      .catch(error => {
        commit('SET_CACHE', { key: 'isSubmitingQuestion', value: false })
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: `${error}` })
        store.dispatch('utils/loaderMessage', '')
      })
  },
  createUpdateModule({ commit, dispatch }, data) {
    store.dispatch('utils/loaderMessage', 'Guardando módulo...')
    commit('SET_CACHE', { key: 'isSubmitingQuestion', value: true })
    let promise = null
    if (data.url) {
      promise = axios.put(data.url, data)
    } else {
      promise = axios.post(appConfig.server_url + `/projects_management/module/`, data)
    }
    promise.then((resp) => {
      commit('SET_CACHE', { key: 'isSubmitingQuestion', value: false })
      store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: `Módulo guardado correctamente` })
      store.dispatch('pronostics/fetchProjects', data.project_ins.id)
      store.dispatch('utils/loaderMessage', '')
      dispatch(
        'fetchQuestions',
        { query: `project__id=${data.project_ins.id}&opc=2`, projectId: data.project_ins.id }
      )
    })
      .catch(error => {
        commit('SET_CACHE', { key: 'isSubmitingQuestion', value: false })
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: `${error}` })
        store.dispatch('utils/loaderMessage', '')
      })
  },
  getModule({ commit }, data) {
    store.dispatch('utils/loaderMessage', 'Cargando módulo...')
    commit('SET_CACHE', { key: 'loadingQuestions', value: true })
    axios.get(appConfig.server_url + `/projects_management/module/${data.id}`)
      .then((resp) => {
        commit('SET_CACHE', { key: 'loadingQuestions', value: false })
        commit('SET_CACHE', { key: 'module', value: resp.data })
        store.dispatch('utils/loaderMessage', '')
      })
      .catch(error => {
        commit('SET_CACHE', { key: 'loadingQuestions', value: false })
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: `${error}` })
        store.dispatch('utils/loaderMessage', '')
      })
  },
  createAnswers({ commit, dispatch }, { answers, question, action, project }) {
    commit('SET_CACHE', { key: 'isSubmitingQuestion', value: true })
    store.dispatch('utils/loaderMessage', 'Guardando preguntas...')
    answers.forEach(element => {
      element.question = question.url
    });
    let promise = null
    let data = {
      answers,
      question
    }
    if (action === 'create') {
      promise = axios.post(appConfig.server_url + `/projects_management/questiondetail/`, data)
    } else {
      promise = axios.put(appConfig.server_url + `/projects_management/questiondetail/update_questionsdetail/`, data)
    }
    promise
      .then((resp) => {
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: `Pregunta guardada correctamente` })
        store.dispatch('utils/loaderMessage', '')
        commit('SET_CACHE', { key: 'isSubmitingQuestion', value: false })
        dispatch(
          'fetchQuestions',
          { query: `project__id=${project.id}&opc=1`, projectId: project.id }
        )
      })
      .catch(error => {
        commit('SET_CACHE', { key: 'isSubmitingQuestion', value: false })
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: `${error}` })
        store.dispatch('utils/loaderMessage', '')
      })
  },
  createAnswersDetail({ commit, dispatch }, { payload, project }) {
    store.dispatch('utils/loaderMessage', 'Guardando respuesta...')
    commit('SET_CACHE', { key: 'isSubmitingAnswer', value: true })
    let promise = null
    let dataHead = {
      explanation: payload.explanation,
      question: payload.url,
      profile: appConfig.server_url + payload.profile
    }
    promise = axios.post(appConfig.server_url + `/projects_management/answer/`, dataHead)
    promise.then((resp) => {
      // store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: `Pregunta guardada correctamente` })
      if (typeof (payload.answers) === 'string') {
        payload.answers = [payload.answers]
        payload.certainties = [payload.certainty]
      }

      payload.answers.forEach((element, index) => {
        let fullAnswers = null
        if (element) {
          fullAnswers = {
            percentage: payload.percentages[index],
            certainty: payload.certainties ? payload.certainties[index] : null,
            answer: resp.data.url,
            question_detail: element
          }
        }

        let promise2 = null
        promise2 = axios.post(appConfig.server_url + `/projects_management/answerdetail/`, fullAnswers)
        promise2.then((resp) => {

          commit('SET_CACHE', { key: 'isSubmitingAnswer', value: false })
          store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: `Respuesta guardada correctamente` })
          store.dispatch('utils/loaderMessage', '')
          dispatch(
            'fetchQuestions',
            { query: `project__id=${project.id}&opc=3`, projectId: project.id }
          )
        })
          .catch(error => {
            console.error({ type: 'error', title: 'Error', text: `${error}` })
            store.dispatch('utils/loaderMessage', '')
            // store.dispatch('utils/message', { type: 'error', title: 'Error', text: `${error}` })
          })

      });

    })
      .catch(error => {
        console.error({ type: 'error', title: 'Error', text: `${error}` })
        // store.dispatch('utils/message', { type: 'error', title: 'Error', text: `${error}` })
        store.dispatch('utils/loaderMessage', '')
      })

  },
  getQuestion({ commit }, data) {
    store.dispatch('utils/loaderMessage', 'Cargando pregunta...')
    commit('SET_CACHE', { key: 'loadingQuestions', value: true })
    axios.get(appConfig.server_url + `/projects_management/question/${data.id}`)
      .then((resp) => {
        commit('SET_CACHE', { key: 'loadingQuestions', value: false })
        commit('SET_CACHE', { key: 'question', value: resp.data })
        store.dispatch('utils/loaderMessage', '')
      })
      .catch(error => {
        commit('SET_CACHE', { key: 'loadingQuestions', value: false })
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: `${error}` })
        store.dispatch('utils/loaderMessage', '')
      })
  },
  deleteModule({ commit, dispatch }, data) {
    store.dispatch('utils/loaderMessage', 'Eliminando módulo...')
    commit('SET_CACHE', { key: 'loadingQuestions', value: true })
    axios.delete(data.url)
      .then((resp) => {
        commit('SET_CACHE', { key: 'loadingQuestions', value: false })
        commit('SET_CACHE', { key: 'question', value: resp.data })
        store.dispatch('pronostics/fetchProjects', data.projectId)
        dispatch(
          'fetchQuestions',
          { query: `project__id=${data.projectId}&opc=2`, projectId: data.projectId }
        )
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: `Módulo eliminado correctamente` })
        store.dispatch('utils/loaderMessage', '')
      })
      .catch(error => {
        commit('SET_CACHE', { key: 'loadingQuestions', value: false })
        dispatch(
          'fetchQuestions',
          { query: `project__id=${data.projectId}&opc=2`, projectId: data.projectId }
        )
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: `${error}` })
        store.dispatch('utils/loaderMessage', '')
      })
  },
  deleteQuestion({ commit, dispatch }, data) {
    store.dispatch('utils/loaderMessage', 'Eliminando pregunta...')
    commit('SET_CACHE', { key: 'loadingQuestions', value: true })
    axios.delete(data.url)
      .then((resp) => {
        commit('SET_CACHE', { key: 'loadingQuestions', value: false })
        commit('SET_CACHE', { key: 'question', value: resp.data })
        store.dispatch('pronostics/fetchProjects', data.projectId)
        dispatch(
          'fetchQuestions',
          { query: `project__id=${data.projectId}&opc=2`, projectId: data.projectId }
        )
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: `Pregunta eliminada correctamente` })
        store.dispatch('utils/loaderMessage', '')
      })
      .catch(error => {
        commit('SET_CACHE', { key: 'loadingQuestions', value: false })
        dispatch(
          'fetchQuestions',
          { query: `project__id=${data.projectId}&opc=2`, projectId: data.projectId }
        )
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: `${error}` })
        store.dispatch('utils/loaderMessage', '')
      })
  },
  createUpdateExceptionQuestion({ commit }, data) {
    store.dispatch('utils/loaderMessage', 'Actualizando excepciones...')
    commit('SET_CACHE', { key: 'loadingQuestions', value: true })
    // console.log(data)
    let deleted = [];
    let inserted = [];

    data.exceptions.forEach(element => {
      let exists = data.exceptionsOptions.find((x) => x.value === element.profile)
      if (typeof exists !== 'object') {
        axios.delete(appConfig.server_url + `/projects_management/questionexception/${element.id}/`)
          .then((resp) => {
            deleted.push(element.id)
            store.dispatch('utils/loaderMessage', 'Eliminando excepción...')
          }).catch(error => {
            store.dispatch('utils/message', { type: 'error', title: 'Error', text: `Ocurrió un error:<br> ${error}` })
          })
      }
    });
    data.exceptionsOptions.forEach(element => {
      let exists = data.exceptions.find((x) => x.profile === element.value)
      if (typeof exists !== 'object') {
        axios.post(appConfig.server_url + `/projects_management/questionexception/`, { profile: element.value, question: data.question.url })
          .then((resp) => {
            inserted.push(element.id)
            store.dispatch('utils/loaderMessage', 'Agregando excepción...')
          }).catch(error => {
            store.dispatch('utils/message', { type: 'error', title: 'Error', text: `Ocurrió un error:<br> ${error}` })
          })
      }
    });
    commit('SET_CACHE', { key: 'loadingQuestions', value: false })
    store.dispatch('utils/loaderMessage', '')
  },
  notificateQuestion({ commit, dispatch }, data) {
    store.dispatch('utils/loaderMessage', 'Notificando pregunta...')
    commit('SET_CACHE', { key: 'loadingQuestions', value: true })
    axios.post(appConfig.server_url + `/projects_management/utils/notificatequestion`, data)
      .then((resp) => {
        commit('SET_CACHE', { key: 'loadingQuestions', value: false })
        console.log("respuesta notificación:", resp)
        if (resp.data.emails && resp.data.emails.length > 0) {
          store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: `Pregunta notificada correctamente a ${resp.data.emails.length} orientador(es)` })
        }
        if (resp.data.errors && resp.data.errors.length > 0) {
          store.dispatch('utils/message', { type: 'error', title: 'Error', text: `Error al notificar a: ${resp.data.errors.length} orientador(es), reintente nuevamente o consulte con soporte técnico.` })
        }
        store.dispatch('utils/loaderMessage', '')
      })
      .catch(error => {
        commit('SET_CACHE', { key: 'loadingQuestions', value: false })
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: `${error}` })
        store.dispatch('utils/loaderMessage', '')
      })
  },

}